import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as authActions from '../../actions/authActions';
import * as sessionActions from '../../actions/sessionActions';
import { authSelector } from '../../selectors';

import { Container, Grid, Button, Header, Form, Message } from 'semantic-ui-react';

class ForgotPasswordPage extends Component {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.onChange = this.onChange.bind(this);
	}
	onSubmit(e) {
		const auth = { ...this.props.auth };

		this.props.actions.forgotPassword(auth.username);
	}
	onChange(e) {
		const auth = { ...this.props.auth };
		auth[e.target.name] = e.target.value;
		this.props.actions.updateUserAuth(auth);
	}
	render() {
		let errorMessage;
		const { passwordSent, error, username } = this.props.auth;
		if (error) {
			const content = Array.isArray(error) ? error.map((e, index) => <div key={index}>{`${e}`}</div>) : error;
			errorMessage = <Message error header='Password Reset' content={content} />;
		}
		return (
			<div className='auth forgot'>
				<Container>
					<Grid columns='equal'>
						<Grid.Column width={7} only='tablet computer' />
						<Grid.Column computer={8} mobile={16} tablet={8}>
							<Form onSubmit={this.onSubmit} loading={this.props.auth.loading} error>
								<Header as='h1' content='Forgot Password' />
								<Header as='h4' content={!passwordSent ? 'Enter your email address and we will send you an email to reset your password.' : 'A password reset email has been sent.'} />
								{!passwordSent ? (
									<Form.Field>
										<input name='username' placeholder='Email Address' onChange={this.onChange} type="email" />
									</Form.Field>
								) : (
									''
								)}
								{errorMessage}

								{!passwordSent ? (
									<Form.Field>
										<Button basic fluid type='submit' disabled={!username}>
											Send
										</Button>
									</Form.Field>
								) : (
									''
								)}
							</Form>
						</Grid.Column>
					</Grid>
				</Container>
			</div>
		);
	}
}

ForgotPasswordPage.propTypes = {
	auth: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
	return {
		auth: authSelector(state)
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: {
			...bindActionCreators(authActions, dispatch),
			...bindActionCreators(sessionActions, dispatch)
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage);
